import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark" | "system";
export type ThemePreset = "red" | "blue" | "green" | "violet" | "slate";

interface ThemeStoreState {
  mode: ThemeMode;
  preset: ThemePreset;
  setMode: (mode: ThemeMode) => void;
  setPreset: (preset: ThemePreset) => void;
}

export const useThemeStore = create<ThemeStoreState>()(
  persist(
    (set) => ({
      // System default — follows the OS appearance until the user
      // picks an explicit Light or Dark in Settings.
      mode: "system",
      // Brand default — the red palette that ships in :root.
      // Other presets override --primary via [data-theme="X"].
      preset: "red",
      setMode: (mode) => set({ mode }),
      setPreset: (preset) => set({ preset }),
    }),
    { name: "pos-theme-settings" },
  ),
);
